module.exports = __webpack_public_path__ + "img/check.74a15e0e.png";